export const FAQS = [
  {
    q: "Berapa biaya jasa listrik di Batam?",
    a: "Biaya tergantung jenis pekerjaan, material, dan lokasi. Untuk perbaikan ringan (jeglek, stop kontak, lampu) mulai dari Rp 150.000. Instalasi baru dihitung per titik. Hubungi kami via WhatsApp untuk estimasi gratis — kami sampaikan rincian sebelum pekerjaan dimulai, tidak ada biaya kejutan.",
  },
  {
    q: "Apakah tersedia layanan 24 jam?",
    a: "Ya. Kami menyediakan layanan panggilan darurat 24 jam untuk kasus kritis seperti korsleting, listrik mati total, atau bahaya kebakaran. Untuk wilayah Batam (Batu Aji, Sekupang, Nagoya, Batam Center, Tiban, dan sekitarnya) respon teknisi rata-rata kurang dari 30 menit.",
  },
  {
    q: "Berapa lama teknisi sampai ke lokasi?",
    a: "Untuk area Batam umumnya 15–30 menit. Untuk Kepulauan Riau (Bintan, Karimun, Natuna, Anambas) biasanya dijadwalkan sesuai proyek. Chat WhatsApp dulu agar kami kirim teknisi terdekat.",
  },
  {
    q: "Apakah pekerjaan bergaransi?",
    a: "Ya. Setiap pekerjaan kami garansi 3–6 bulan tergantung jenis layanan. Jika terjadi masalah yang sama dalam masa garansi, kami kembali tanpa biaya tambahan.",
  },
  {
    q: "Layanan apa saja yang tersedia?",
    a: "Instalasi & perbaikan listrik, service AC (cuci/isi freon/AC tidak dingin), instalasi CCTV, service mesin cuci & kulkas, instalasi water heater, pembuatan panel industri, hingga perbaikan modul PCB ringan. Semua dalam satu tim teknis terpadu.",
  },
  {
    q: "Apakah melayani kantor pemerintah dan pabrik?",
    a: "Ya, kami berpengalaman menangani proyek rumah tangga hingga skala industri dan instansi pemerintah. Termasuk panel industri, maintenance rutin pabrik, dan kontrak jangka panjang untuk gedung komersial.",
  },
  {
    q: "Apakah teknisinya bersertifikat?",
    a: "Ya. Tim teknisi kami memiliki sertifikat kompetensi ketenagalistrikan dan bekerja sesuai standar PUIL 2011 serta SNI. Untuk proyek besar kami juga menyertakan Sertifikat Layak Operasi (SLO).",
  },
  {
    q: "Apakah bisa panggilan ke lokasi?",
    a: "Tentu. Kami adalah layanan panggilan (on-call). Cukup chat WhatsApp dengan kondisi masalah & lokasi Anda, teknisi akan langsung meluncur ke tempat Anda.",
  },
];
